import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { CircleCheck, ShieldCheck, Award, ClipboardCheck, ThumbsUp, House as Home, Leaf } from 'lucide-react';
const certifications = [{
  title: "MITSUBISHI ELECTRIC CERTIFIED INSTALLER",
  description: "Successfully completed the Mitsubishi Electric Ecodan Heat Pump Installation & Commissioning Programme (2025). Specialist training in the installation, commissioning and optimisation of Ecodan heat pump systems.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/mitsubishi_electric_logo.png",
  accentColor: "text-red-600",
  borderColor: "border-red-200",
  features: ["Heat Pump Installations", "Energy Retrofit Projects", "Renewable Heating Solutions", "System Commissioning & Testing"]
}, {
  title: "PAT TESTING CERTIFIED",
  description: "Certified in Portable Appliance Testing (PAT) through Powerpoint Engineering. Ensures electrical appliances are tested to current safety standards, keeping your business, workplace and premises safe and compliant.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/powerpoint_engineering_logo.png",
  accentColor: "text-green-600",
  borderColor: "border-green-200",
  features: ["Portable Appliance Testing (PAT)", "Workplace Safety Compliance", "Commercial & Industrial Testing", "Landlord Electrical Safety Checks"]
}, {
  title: "QQI LEVEL 6 ADVANCED CERTIFICATE IN ELECTRICAL CRAFT",
  description: "Awarded with Distinction. A nationally recognised qualification demonstrating advanced knowledge, technical competence and professional expertise across all areas of electrical installation and maintenance.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678780/img/qqi_logo.png",
  accentColor: "text-blue-800",
  borderColor: "border-blue-200",
  features: ["Domestic Electrical Installations", "Commercial Electrical Services", "Agricultural Electrical Services", "Electrical Maintenance & Repairs", "Testing & Certification"]
}];
const trustBadges = [{
  icon: ShieldCheck,
  title: "FULLY QUALIFIED",
  subtitle: "Electrician"
}, {
  icon: Award,
  title: "INDUSTRY RECOGNISED",
  subtitle: "Certifications"
}, {
  icon: ClipboardCheck,
  title: "COMPLIANT & INSURED",
  subtitle: "For Your Peace of Mind"
}, {
  icon: ThumbsUp,
  title: "RELIABLE & TRUSTED",
  subtitle: "Local Expert"
}, {
  icon: Home,
  title: "DOMESTIC COMMERCIAL AGRICULTURAL",
  subtitle: "We Cover It All"
}, {
  icon: Leaf,
  title: "ENERGY EFFICIENT SOLUTIONS",
  subtitle: "For a Greener Future"
}];
export default function TrustedByTeachersEverywhere() {
  return <section data-section-id="261873" id="certified-excellence" className="w-full py-20 border-y border-border/60 overflow-hidden bg-muted light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 gap-4">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter uppercase">
            Our <span className="text-accent-foreground bg-accent px-2">Accreditations</span> & Certifications
          </h2>
          <p className="text-lg md:text-xl font-medium text-muted-foreground max-w-2xl">
            Quality. Compliance. Expertise. You're in Safe Hands.
          </p>
          <div className="h-1 w-24 bg-accent mt-2" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          {certifications.map((cert, i) => <div key={i} data-index={i} className={`flex flex-col p-8 rounded-lg border-2 ${cert.borderColor} bg-card transition-all duration-300 hover:shadow-xl`}>
              <div className="h-24 flex items-center justify-center mb-8">
                <img src={cert.logo} alt={cert.title} className="max-h-full w-auto object-contain" data-wvc-srcset={`${cert.logo}-wvc-srcset`} data-wvc-sizes={`${cert.logo}-wvc-sizes`} loading="lazy" />
              </div>
              
              <h3 className={`text-lg font-bold text-center mb-4 leading-tight ${cert.accentColor}`}>
                {cert.title}
              </h3>
              
              <p className="text-sm text-muted-foreground text-center mb-8 leading-relaxed">
                {cert.description}
              </p>
              
              <div className="mt-auto space-y-3">
                {cert.features.map((feature, idx) => <div key={idx} className="flex items-start gap-3">
                    <CircleCheck className={`h-5 w-5 shrink-0 ${cert.accentColor}`} />
                    <span className="text-sm font-semibold text-foreground">{feature}</span>
                  </div>)}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 py-8 border-y border-border/40">
          {trustBadges.map((badge, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center gap-3">
              <div className="p-3 rounded-lg bg-accent/10 text-accent-foreground">
                <badge.icon className="h-8 w-8" />
              </div>
              <div className="space-y-1">
                <h4 className="text-[10px] font-bold tracking-wider uppercase leading-none">
                  {badge.title}
                </h4>
                <p className="text-[10px] text-muted-foreground font-mono">
                  {badge.subtitle}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-primary/60">
            Trained. Certified. Committed to Excellence.
          </p>
        </div>
      </div>
    </section>;
}